import { ReactNode, useMemo } from 'react'

import { AppBar, AppBarProps, Stack, Toolbar } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Logo } from '@weberlo/components'

import Workspaces from 'sections/workspaces'
import Birdeatsbug from '../../MainLayout/Header/Helpdesk'
import Profile from './Profile'

const Header = () => {
  const theme = useTheme()

  // header content
  const headerProfile = useMemo(() => <Profile />, [])
  const headerWorkspaces = useMemo(() => <Workspaces />, [])
  const birdeatsbug = useMemo(() => <Birdeatsbug />, [])

  // common header
  const mainHeader: ReactNode = (
    <Toolbar
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: '1660px',
        borderBottom: `1px solid ${theme.palette.primary.light}`,
        paddingBottom: 0,
        paddingTop: 0,
        minHeight: '80px',
      }}>
      <Logo to={'/subscription'} />
      <Stack
        direction="row"
        spacing={2}
        alignItems="center">
        {birdeatsbug}
        {headerWorkspaces}
        {headerProfile}
      </Stack>
    </Toolbar>
  )

  // app-bar params
  const appBar: AppBarProps = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      zIndex: 1200,
      // boxShadow: theme.customShadows.z1
    },
  }

  const style = {
    backgroundColor: theme.palette.secondary.contrastText,
    border: 0,
    borderTop: 0,
    borderRight: 0,
  }

  return (
    <AppBar
      {...appBar}
      sx={style}>
      {mainHeader}
    </AppBar>
  )
}

export default Header
